import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { EventPeriod } from '../component/event-period';
import { SeparatorTitle } from '../component/separator-title';
import { competitionBunja, competitionTabsBunja } from '../state';
import { competitionContentBunja } from './state';

export const EventTitle = () => {
  const { competitionAtom, dailyCheckInAtom } = useBunja(competitionBunja);
  const { eventTabTitleAtom, eventTabSubtitleAtom } = useBunja(competitionContentBunja);
  const { selectedEventTabValueAtom } = useBunja(competitionTabsBunja);
  const competition = useAtomValue(competitionAtom);
  const eventTabTitle = useAtomValue(eventTabTitleAtom);
  const eventTabSubtitle = useAtomValue(eventTabSubtitleAtom);
  const selectedEventTabValue = useAtomValue(selectedEventTabValueAtom);
  const dailyCheckIn = useAtomValue(dailyCheckInAtom);

  if (selectedEventTabValue === 'daily-check-in') {
    return (
      <SeparatorTitle
        colorSet='keyColor'
        subtitle={eventTabSubtitle}
        title={eventTabTitle}
        description={<EventPeriod start={dailyCheckIn?.startDate} end={dailyCheckIn?.endDate} />}
      />
    );
  }

  return (
    <SeparatorTitle
      colorSet='keyColor'
      subtitle={eventTabSubtitle}
      title={eventTabTitle}
      description={<EventPeriod start={competition?.competitionStartTime} end={competition?.competitionEndTime} />}
      css={{ mb: 24 }}
    />
  );
};
